import {Button, Form} from "antd";
import {t} from "i18next";
import UserSelectList from "../../user/UserSelectList";
import React, {useState} from "react";
import ApiService from "../../../core/service/ApiService";

export default function EntitlementConfirmationForm({onOk, appointments}) {
    const [selectedUser, setSelectedUser] = useState(null);

    return (
        <Form>
            <Form.Item
                name={'confirmUser'}
                label={t('Users')}
            >
                <UserSelectList
                    onChange={(value) => setSelectedUser(value)}
                    showEntitlementConfirmUser={true}
                />
            </Form.Item>
            <Form.Item>
                <Button
                    size={'small'}
                    onClick={async () => {
                        debugger
                        const res = await ApiService.Entitlement.SendConfirmation({
                            userId: selectedUser,
                            appointmentIdList: appointments.map(x => x.appointmentId),
                        });

                        if(res.success) {
                            onOk(res.data);
                        }
                    }}
                >
                    {t('Send for Confirmation')}
                </Button>
            </Form.Item>
        </Form>
    )
}